import { EventSourcePolyfill } from 'event-source-polyfill'
import { backendUrl } from '../../api/apiConfig'
import { getAuthHeaders } from '../../api/axiosClient'

export type ChatStreamRequest = {
  message: string
  chatId?: string
  agentId?: string
  fileIds?: string[]
}

export async function getChatStreamerEvent({
  chatId,
  agentId,
  message,
  fileIds,
}: ChatStreamRequest): Promise<EventSourcePolyfill> {
  try {
    const authHeaders = await getAuthHeaders()

    const params = new URLSearchParams({
      message: message,
      conversation_id: chatId || '',
    })

    // Add file_ids to query parameters if provided
    if (fileIds && fileIds.length > 0) {
      fileIds.forEach(fileId => {
        params.append('file_ids', fileId)
      })
    }

    // Always use the agent stream endpoint
    const url = `${backendUrl}api/chat/agents/${agentId}/stream?${params.toString()}`;

    return new EventSourcePolyfill(url, {
      headers: authHeaders,
      withCredentials: true,
    })
  } catch (error) {
    console.error('Error creating EventSource:', error)
    throw new Error('Failed to connect to the server. Please check your network connection and try again.')
  }
}
